import Axios from "../../api/Axios";
const BASE_URL = "UploadDownload/";

export const EndpointUploadDownload = {
    UploadFile: "UploadFile",
    DownloadFile: "DownloadFile"
};

export const createAPIEndpointUploadDownload = () => {
    return { 
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };

};
